import { render, staticRenderFns } from "./AiReportInfoViewer.vue?vue&type=template&id=0e4845c4&scoped=true&"
import script from "./AiReportInfoViewer.vue?vue&type=script&lang=ts&"
export * from "./AiReportInfoViewer.vue?vue&type=script&lang=ts&"
import style0 from "./AiReportInfoViewer.vue?vue&type=style&index=0&id=0e4845c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4845c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
